module.exports = __webpack_public_path__ + "static/uncommon-genius-b3ca06600813ce4949af793df09c26db.jpg";